// redux/store.ts

import authReducer from "./redux/auth";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { apiSlice } from "./initalState";
import { trackingApiSlice } from "./api/trackingApiSlice";
import { vehicleApi } from "./api/vehicleApi";
import { vehiclesApi } from "./api/vehicle";
import { driverApi } from "./api/driver";
import { dashboardSlice } from "./api/dashboard";

import { documentApi } from "./api/document";

export const trackingLogo =
  "https://schooleg.s3.ap-south-1.amazonaws.com/Misc/1746638529543_logo2.png";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [trackingApiSlice.reducerPath]: trackingApiSlice.reducer,
    [vehicleApi.reducerPath]: vehicleApi.reducer,
    [vehiclesApi.reducerPath]: vehiclesApi.reducer,
    [dashboardSlice.reducerPath]: dashboardSlice.reducer,
    [driverApi.reducerPath]: driverApi.reducer,

    [documentApi.reducerPath]: documentApi.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(trackingApiSlice.middleware)
      .concat(vehicleApi.middleware)
      .concat(vehiclesApi.middleware)
      .concat(driverApi.middleware)
      .concat(dashboardSlice.middleware)
      .concat(documentApi.middleware)

});

setupListeners(store.dispatch);

export default store;
